export enum STORY_SUBGROUPS {
  IPM = 'IPM',
  PRE_IPM = 'PRE_IPM',
  DRAFT = 'DRAFT',
}
